"use client";
"use i18n";

import { useLingoContext } from "@lingo.dev/compiler/react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@workspace/ui/components/select";

const LOCALES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale } = useLingoContext();
  return (
    <Select
      items={LOCALES.map((l) => ({ value: l.code, label: l.label }))}
      value={locale}
      onValueChange={(v) =>
        v && setLocale(v as Parameters<typeof setLocale>[0])
      }
    >
      <SelectTrigger aria-label="Language" size="sm" className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LOCALES.map((l) => (
          <SelectItem key={l.code} value={l.code}>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
